import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

function getVisitorId() {
  let v = localStorage.getItem("gybc_vid");
  if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("gybc_vid", v); }
  return v;
}
function getSessionId() {
  let s = sessionStorage.getItem("gybc_sid");
  if (!s) { s = Math.random().toString(36).slice(2); sessionStorage.setItem("gybc_sid", s); }
  return s;
}

export default function useVisitorTracking() {
  const location = useLocation();
  const current = useRef({ id: null, start: 0 });

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;

    const flush = () => {
      const { id, start } = current.current;
      if (!id) return;
      const seconds = Math.round((Date.now() - start) / 1000);
      const body = JSON.stringify({ id, seconds });
      try {
        navigator.sendBeacon?.(`${api.defaults.baseURL}/track/dwell`, new Blob([body], { type: "application/json" }));
      } catch (e) { api.post("/track/dwell", { id, seconds }); }
    };

    flush(); // flush previous page's dwell before recording the new view

    api.post("/track/view", {
      visitor_id: getVisitorId(),
      session_id: getSessionId(),
      path: location.pathname,
      referrer: document.referrer,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      language: navigator.language,
    }).then((r) => { current.current = { id: r.data.id, start: Date.now() }; }).catch(() => {});

    window.addEventListener("beforeunload", flush);
    return () => { flush(); window.removeEventListener("beforeunload", flush); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
}
